export const validatePasswordConfirm = (value, callback, password) => {
  if (value === "") {
    callback(new Error('Please enter your password again'));
  } else if (value !== password) {
    callback(new Error('The two input passwords do not match!'));
  } else {
    callback();
  }
};

const validateWhiteSpaces = (rule, value, callback) => {
  if (/\s/.test(value)) {
    callback(new Error('Your password must not contain whitespaces'));
  } else {
    callback();
  }
};

const validateCyrillic = (rule, value, callback) => {
  if (/[а-яА-Я]/.test(value)) {
    callback(new Error('Your password must not contain non-Latin letters'));
  } else {
    callback();
  }
};

export const bcrWallet = [
  {
    required: true,
    type: "string",
    message: "Please fill in the BCR wallet.",
    trigger: "blur"
  }
];
 
export const bcrWalletBalance = [
  {
    required: true,
    type: "string",
    message: "Please fill in the BCR balance.",
    trigger: "blur"
  },
  {
    type: "string",
    pattern: /^(\d+\.?\d*|\.\d+)$/,
    message: "Only numbers and one dot can be entered",
    trigger: "blur",
  },
];

export const tprWallet = [
  {
    required: true,
    type: "string",
    message: "Please fill in the TPR wallet.",
    trigger: "blur"
  }
];

export const login = [
  {
    required: true,
    message: "Please fill in the login name",
    trigger: "blur",
  },
  {           
    min: 3,
    message: "User name should be from 3 to 20 characters.",
    trigger: "blur"         
  }, 
  {           
    max: 20,
    message: "User name should be from 3 to 20 characters.",
    trigger: "blur"         
  },
];
  
export const firstName = [
  {
    required: true,
    message: "Please fill in the first name",
    max: 30,
    message: "Min from 3 to 30 characters.",
    min: 3,
    message: "Min from 3 to 30 characters.",
    trigger: "blur",
  },
];
   
export const lastName = [
  {
    required: true,
    message: "Please fill in the last name",
    max: 20,
    message: "Min from 3 to 20 characters.",
    min: 3,
    message: "Min from 3 to 20 characters.",
    trigger: "blur",
  },
];

export const email = [
  {
    required: true,
    message: "Please fill in the email",
    trigger: "blur",
  },
  {
    type: "string",
    pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    message: "Please input correct email",
    trigger: "blur",
  },
];
  
export const phone = [
  {
    required: true,
    message: "Please fill in the phone",
    trigger: "blur",
  },
];

export const password = [
  {
    required: true,
    message: "Please fill in the password.",
    trigger: "blur",
  },
  {           
    validator: validateWhiteSpaces,
    trigger: "blur"
  },
  {           
    validator: validateCyrillic,
    trigger: "blur"
  },
  {           
    min: 8,
    message: "Your Password should be from 8 to 20 characters.",
    trigger: "blur"
  }, 
  {           
    max: 20,
    message: "Your Password should be from 8 to 20 characters.",
    trigger: "blur"
  },
  {           
    type: "string",
    pattern: /^(?=.*?[A-Z])(?=.*?[a-z])/,
    message: "It must contain a combination of uppercase and lowercase",
    trigger: "blur"
  }, 
  {           
    type: "string",
    pattern: /^(?=.*?[0-9])/,
    message: "It must contain a one digit",
    trigger: "blur"         
  },
];